import * as React from "react";
import { CenterAction } from "@nkr/enums/index";
import { ICellRendererParams } from "ag-grid-community";
import { DropdownButton, MenuItem } from "react-bootstrap";
import { CenterActions } from "./center-actions";
import OverlayMenuButton from "@nkr/components/overlay-menu-button";

interface IProps { }

export class ActionButtonRenderer extends React.Component<ICellRendererParams & IProps, {}> {
    handlers = {
        [CenterAction.Cpr]: CenterActions.handleCpr,
        [CenterAction.Pairs]: CenterActions.handlePairs,
        [CenterAction.Login]: CenterActions.handleLogin,
        [CenterAction.Edit]: CenterActions.handleEdit,
        [CenterAction.Contacts]: CenterActions.handleContacts,
        [CenterAction.ActionCenter]: CenterActions.handleActionCenter,
        [CenterAction.AccountPlan]: CenterActions.handleAccountPlan
    };

    handleMenuSelection = (e: any) => {
        let action = parseInt(e);

        if (this.handlers.hasOwnProperty(action)) {
            return this.handlers[action](this.props.data.id);
        }
    }

    handleAction = (id: number, action: CenterAction) => {
        if (this.handlers.hasOwnProperty(action)) {
            return this.handlers[action](this.props.data.id);
        }
    }

    render = () => {
        const dataLength = this.props.api.getModel().getRowCount();
        const dropup = dataLength <= 18 ? false : this.props.rowIndex + 1 > dataLength - 6;

        return (
            <DropdownButton id={`action-menu-${this.props.data.id}`} dropup={dropup} title="Action" bsStyle="primary" bsSize="xs" onSelect={this.handleMenuSelection}>
                <MenuItem eventKey={1}>CPR</MenuItem>
                <MenuItem eventKey={2}>Pairs</MenuItem>
                <MenuItem eventKey={3}>Login</MenuItem>
                <MenuItem eventKey={4}>Edit</MenuItem>
                <MenuItem eventKey={5}>Contacts</MenuItem>
                <MenuItem eventKey={6}>Action Center</MenuItem>
                <MenuItem eventKey={7}>Account Plan</MenuItem>
            </DropdownButton>
        );
    }

    // render = () => {
    //     const menu = [
    //         { id: this.props.data.id, action: CenterAction.Clc, include: true, selectable: true, element: <>CLC</> },
    //         { id: this.props.data.id, action: CenterAction.Pairs, include: true, selectable: true, element: <>Pairs</> },
    //         { id: this.props.data.id, action: CenterAction.Login, include: true, selectable: true, element: <>Login</> },
    //         { id: this.props.data.id, action: CenterAction.Edit, include: true, selectable: true, element: <>Edit</> },
    //         { id: this.props.data.id, action: CenterAction.Contacts, include: true, selectable: true, element: <>Contacts</> },
    //         { id: this.props.data.id, action: CenterAction.ActionCenter, include: true, selectable: true, element: <>Action Center</> },
    //         { id: this.props.data.id, action: CenterAction.AccountPlan, include: true, selectable: true, element: <>Account Plan</> },
    //     ];

    //     return (
    //         <OverlayMenuButton
    //             bsStyle='primary'
    //             bsSize='xs'
    //             title='Actions'
    //             menu={menu}
    //             onSelect={this.handleAction}
    //         />
    //     );
    // }
}